import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function ApplicationContent({
  handleEdit,
  settingId,
  showSingleSetting,
  settingInfo,
}) {
  useEffect(() => {
    if (_.isEmpty(settingId)) return;
    showSingleSetting(settingId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(settingId)) return;
    showSingleSetting(settingId);
  }, [settingId]);
  return (
    <div className="container-fluid card-section-content">
      {!_.isEmpty(settingInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="col-8">
                  <h3 className="">
                    {' '}
                    {_.get(settingInfo, 'attributes.name') || '--'}
                  </h3>
                </div>
                <div className="col-4 d-flex">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(settingInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12">
                    <div className="form-wrapper mb-3">
                      <div className="full-group border-bottom">
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">
                              Max no. of pending applicants allowed prior to submission:
                            </label>
                            <span className="full-input">
                              {_.get(settingInfo, 'attributes.max_pending_applications') ||
                                '--'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

ApplicationContent.propTypes = {
  handleEdit: PropTypes.instanceOf(Function).isRequired,

  showSingleSetting: PropTypes.instanceOf(Function).isRequired,
  settingInfo: PropTypes.instanceOf(Object).isRequired,
  settingId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  settingInfo: _.get(api, `${c.GET_SINGLE_SETTING}.item`) || {},
  settingId: _.get(match, 'params.settingId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ApplicationContent);
